import { useCallback } from 'react';
import { copyToClipboard } from '../utils/helperFunction/copyToClipboard';
import useIonicToast from './useIonicToast';
type UseClipboardOptions = {
  onSuccessMessage?: string;
  onErrorMessage?: string;
};

export function useClipboard(value?: string, options?: UseClipboardOptions) {
  const { presentIonToast } = useIonicToast();
  const handleClick = useCallback(
    (newValue?: string) => {
      if (!newValue && !value) return;
      try {
        copyToClipboard(newValue || value!);
        presentIonToast(options?.onSuccessMessage || 'Code copied', 'regular');
      } catch (error: any) {
        console.error(error.message);
        presentIonToast(
          options?.onErrorMessage || 'Code failed to copy',
          'error'
        );
      }
    },
    [value, presentIonToast, copyToClipboard, options]
  );

  return { copy: handleClick };
}
